import { ButtonContainer, DataTable, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { FcbFormateurTitreGridDto, FichierApi, FormateurTitreApi, FormateurTitreSearch } from "../../../../../../api";
import { ERoutes } from "../../../../../../AppRouter";
import { EditButton, LinkButton, ViewButton } from "../../../../../../components";
import { useApiService, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";

export interface IActiviteProfessionnelleTitreListPageProps {
  idFormateur: number;
}

export const ActiviteProfessionnelleTitreListPage: React.FunctionComponent<IActiviteProfessionnelleTitreListPageProps> = ({
  idFormateur
}) => {
  const { t } = useTl();
  const api = useApiService(FormateurTitreApi);
  const history = useHistory();
  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
    sortKeys: { libelle: "ASC" }
  });

  const searchFunction = React.useCallback(
    (sObj?: FormateurTitreSearch) => {
      sObj.idformateur = idFormateur;
      return api.formateurTitreBaseSearch({ FormateurTitreSearch: sObj });
    },
    [api, idFormateur]
  );

  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true
  });

  const fapi = useApiService(FichierApi);
  const downloadFn = React.useCallback(async idfichier => await fapi.fichierDownload({ id: idfichier }), [fapi]);

  const columns = React.useMemo(
    () => [
      {
        computed: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: FcbFormateurTitreGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() =>
                history.push(
                  `${ERoutes.formateur}/${idFormateur}/activitesProfessionnelles/Titre/${row.idtitreFormateur}/view`
                )
              }
            />
            <EditButton
              minimal={true}
              onClick={() =>
                history.push(
                  `${ERoutes.formateur}/${idFormateur}/activitesProfessionnelles/Titre/${row.idtitreFormateur}/edit`
                )
              }
            />
          </ButtonContainer>
        )
      },
      {
        header: () => t(ETLCodes.Libelle),
        fieldName: "libelle"
      },
      {
        header: () => t(ETLCodes.Titre),
        fieldName: "titre"
      },
      {
        header: () => t(ETLCodes.Date),
        fieldName: "date"
      },
      {
        header: () => t(ETLCodes.Document),
        fieldName: "fichier",
        render: (row: FcbFormateurTitreGridDto) =>
          row.fileName &&
          (row.idfichier ? <LinkButton text={row.fileName} onClick={() => downloadFn(row.idfichier)} /> : row.fileName)
      }
    ],
    [downloadFn, history, idFormateur, t]
  );

  return (
    <DataTable
      dateFormat="dd-MM-yyyy"
      tableState={tableState}
      loading={loading}
      columns={columns}
      filterMode="OnEnter"
    />
  );
};
